import * as React from 'react';
import { TabIdType, TabItemType } from './MainViewTypes';
import { MainViewTab } from './MainViewTab';
import { observer } from 'src/utils/mobx-react';
import { AppState } from 'src/appState/AppState';
import {
    MainViewMain,
    MainViewTranslations,
    FeaturesFlagTab,
    MainViewCasino,
    CurrentEvent,
    TagStatistics,
} from './Tabs';
import { RouteViewType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { TabWrapper } from './DebugPanel.style';
import { useCommon } from 'src/domains/common/Common';
import { DebugPanelState } from 'src/domains/layouts/webview/components/debugPanel/DebugPanelState';

const Tabs: Array<TabItemType> = [
    {
        id: 'main',
        name: 'Main',
        body: (): React.ReactElement => <MainViewMain />,
    },
    {
        id: 'translations',
        name: 'Translations',
        body: (): React.ReactElement => <MainViewTranslations />,
    },
    {
        id: 'config',
        name: 'Website Config',
        body: (): React.ReactElement => <FeaturesFlagTab />,
    },
    {
        id: 'casino',
        name: 'Casino',
        body: (): React.ReactElement => <MainViewCasino />,
    },
    {
        id: 'event',
        name: 'Current Event',
        body: (_, currentView: RouteViewType | undefined): React.ReactElement => (
            <CurrentEvent currentView={currentView} />
        ),
    },
    {
        id: 'tags',
        name: 'Tag statistics',
        body: (appState: AppState): React.ReactElement => <TagStatistics appState={appState} />,
    },
];

const getTabBody = (id: TabIdType | null, appState: AppState, currentView: RouteViewType): React.ReactElement => {
    for (const item of Tabs) {
        if (item.id === id) {
            return item.body(appState, currentView);
        }
    }

    return <MainViewTranslations />;
};

interface PropsType {
    appState: AppState;
    currentView: RouteViewType;
}

export const MainView = observer('MainView', ({ appState, currentView }: PropsType) => {
    const common = useCommon();
    const debugPanel = DebugPanelState.get(common);
    const activeTab = debugPanel.activeTab;
    const body = getTabBody(activeTab, appState, currentView);

    const out: Array<React.ReactNode> = [];

    for (const tabItem of Tabs) {
        out.push(
            <MainViewTab
                key={tabItem.id}
                tabId={tabItem.id}
                name={tabItem.name}
            />
        );
    }

    return (
        <>
            <TabWrapper>{out}</TabWrapper>
            {body}
        </>
    );
});
